import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="upload"
export default class extends Controller {
  static targets = ["fileName", "remove", "placeholder", "input", "preview", "currentImage"];

  connect() {}

  updateFileName() {
    const input = this.inputTarget;
    const fileName = input.files[0]?.name || "No file chosen";
    this.fileNameTarget.textContent = fileName;

    if (input.files && input.files[0]) {
      const reader = new FileReader();
      reader.onload = (e) => {
        // Anytime a new image is loaded after input opens
        this.previewTarget.src = e.target.result;
        this.previewTarget.classList.remove("hidden");

        // Hide the placeholder when showing preview
        if (this.hasPlaceholderTarget) {
          this.placeholderTarget.classList.add("hidden");
        }

        // Hide the current image when showing preview
        if (this.hasCurrentImageTarget) {
          this.currentImageTarget.classList.add("hidden");
        }

        if (this.hasRemoveTarget) {
          this.removeTarget.checked = false; // Uncheck the remove checkbox if no file is selected
        }
      };
      reader.readAsDataURL(input.files[0]);
    } else {
      // When there is no file on the record and file input is opeeed but then canceled
      this.previewTarget.src = "#";
      this.previewTarget.classList.add("hidden");

      // Show the placeholder when no file is selected
      if (this.hasPlaceholderTarget) {
        this.placeholderTarget.classList.remove("hidden");
      }

      // Show the current image again when no file is selected
      if (this.hasCurrentImageTarget) {
        this.currentImageTarget.classList.remove("hidden");
      }
    }
  }
}
